var map = {
	"./en-CA.yaml": [
		534,
		[
			358
		]
	],
	"./en-US.yaml": [
		3342,
		[
			167
		]
	],
	"./es-US.yaml": [
		6159,
		[
			156
		]
	],
	"./fr-CA.yaml": [
		9635,
		[
			549
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77;
module.exports = webpackAsyncContext;